import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import PageHero from '../components/layout/PageHero';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt, FaBriefcase, FaHardHat, FaTools, FaPencilRuler } from 'react-icons/fa';

// Fonction pour obtenir l'icône appropriée en fonction du titre du poste
export const getJobIcon = (title) => {
  const titleLower = title.toLowerCase();
  
  // Ingénierie / Bureau d'études
  if (
    titleLower.includes('ingénieur') ||
    titleLower.includes('engineer') ||
    titleLower.includes('technicien études') ||
    titleLower.includes('technician design') ||
    titleLower.includes('dessinateur') ||
    titleLower.includes('drafter') ||
    titleLower.includes('topographe') ||
    titleLower.includes('surveyor')
  ) {
    return <FaPencilRuler className="text-socabeg-blue" />;
  }

  // Chantiers / Production
  if (
    titleLower.includes('chef de chantier') ||
    titleLower.includes('conducteur de travaux') ||
    titleLower.includes('maçon') ||
    titleLower.includes('mason') ||
    titleLower.includes('coffreur') ||
    titleLower.includes('ferrailleur') ||
    titleLower.includes('électricien') ||
    titleLower.includes('electrician') ||
    titleLower.includes('plombier') ||
    titleLower.includes('plumber') ||
    titleLower.includes('ouvrier') ||
    titleLower.includes('worker') ||
    titleLower.includes('chantier') ||
    titleLower.includes('site')
  ) {
    return <FaHardHat className="text-socabeg-blue" />;
  }

  // Comptabilité & Finances
  if (
    titleLower.includes('comptable') ||
    titleLower.includes('accountant') ||
    titleLower.includes('finance') ||
    titleLower.includes('financial') ||
    titleLower.includes('contrôleur de gestion') ||
    titleLower.includes('controller') ||
    titleLower.includes('trésorier') ||
    titleLower.includes('treasurer')
  ) {
    return <FaBriefcase className="text-socabeg-blue" />;
  }

  // Achats
  if (
    titleLower.includes('acheteur') ||
    titleLower.includes('achats') ||
    titleLower.includes('purchaser') ||
    titleLower.includes('procurement') ||
    titleLower.includes('approvisionnement')
  ) {
    return <FaTools className="text-socabeg-blue" />;
  }

  // Par défaut : administration / autres
  return <FaBriefcase className="text-socabeg-blue" />;
};

// Fonction pour obtenir les offres d'emploi avec les traductions
// Limité volontairement à 10 offres (réparties entre CDI, CDD et Stage via les traductions)
export const getJobListings = (t) => [
  {
    id: 1,
    title: t('careers.job1.title'),
    location: 'Dakar',
    company: t('careers.job1.company'),
    type: 'CDI',
    typeLabel: t('careers.job1.type'),
    description: t('careers.job1.description'),
    requirements: t('careers.job1.requirements', { returnObjects: true }),
    responsibilities: t('careers.job1.responsibilities', { returnObjects: true })
  },
  {
    id: 2,
    title: t('careers.job2.title'),
    location: 'Dakar',
    company: t('careers.job2.company'),
    type: 'CDI',
    typeLabel: t('careers.job2.type'),
    description: t('careers.job2.description'),
    requirements: t('careers.job2.requirements', { returnObjects: true }),
    responsibilities: t('careers.job2.responsibilities', { returnObjects: true })
  },
  {
    id: 3,
    title: t('careers.job3.title'),
    location: 'Dakar',
    company: t('careers.job3.company'),
    type: 'CDI',
    typeLabel: t('careers.job3.type'),
    description: t('careers.job3.description'),
    requirements: t('careers.job3.requirements', { returnObjects: true }),
    responsibilities: t('careers.job3.responsibilities', { returnObjects: true })
  },
  {
    id: 4,
    title: t('careers.job4.title'),
    location: 'Dakar',
    company: t('careers.job4.company'),
    type: 'CDD',
    typeLabel: t('careers.job4.type'),
    description: t('careers.job4.description'),
    requirements: t('careers.job4.requirements', { returnObjects: true }),
    responsibilities: t('careers.job4.responsibilities', { returnObjects: true })
  },
  {
    id: 5,
    title: t('careers.job5.title'),
    location: 'Dakar',
    company: t('careers.job5.company'),
    type: 'CDD',
    typeLabel: t('careers.job5.type'),
    description: t('careers.job5.description'),
    requirements: t('careers.job5.requirements', { returnObjects: true }),
    responsibilities: t('careers.job5.responsibilities', { returnObjects: true })
  },
  {
    id: 6,
    title: t('careers.job6.title'),
    location: 'Dakar',
    company: t('careers.job6.company'),
    type: 'CDD',
    typeLabel: t('careers.job6.type'),
    description: t('careers.job6.description'),
    requirements: t('careers.job6.requirements', { returnObjects: true }),
    responsibilities: t('careers.job6.responsibilities', { returnObjects: true })
  },
  {
    id: 7,
    title: t('careers.job7.title'),
    location: 'Dakar',
    company: t('careers.job7.company'),
    type: 'Stage',
    typeLabel: t('careers.job7.type'),
    description: t('careers.job7.description'),
    requirements: t('careers.job7.requirements', { returnObjects: true }),
    responsibilities: t('careers.job7.responsibilities', { returnObjects: true })
  },
  {
    id: 8,
    title: t('careers.job8.title'),
    location: 'Dakar',
    company: t('careers.job8.company'),
    type: 'Stage',
    typeLabel: t('careers.job8.type'),
    description: t('careers.job8.description'),
    requirements: t('careers.job8.requirements', { returnObjects: true }),
    responsibilities: t('careers.job8.responsibilities', { returnObjects: true })
  },
  {
    id: 9,
    title: t('careers.job9.title'),
    location: 'Dakar',
    company: t('careers.job9.company'),
    type: 'Stage',
    typeLabel: t('careers.job9.type'),
    description: t('careers.job9.description'),
    requirements: t('careers.job9.requirements', { returnObjects: true }),
    responsibilities: t('careers.job9.responsibilities', { returnObjects: true })
  },
  {
    id: 10,
    title: t('careers.job10.title'),
    location: 'Dakar',
    company: t('careers.job10.company'),
    type: 'CDI',
    typeLabel: t('careers.job10.type'),
    description: t('careers.job10.description'),
    requirements: t('careers.job10.requirements', { returnObjects: true }),
    responsibilities: t('careers.job10.responsibilities', { returnObjects: true })
  },
  // Comptabilité (11–13)
  {
    id: 11,
    title: t('careers.job11.title'),
    location: 'Dakar',
    company: t('careers.job11.company'),
    type: 'CDI',
    typeLabel: t('careers.job11.type'),
    description: t('careers.job11.description'),
    requirements: t('careers.job11.requirements', { returnObjects: true }),
    responsibilities: t('careers.job11.responsibilities', { returnObjects: true })
  },
  {
    id: 12,
    title: t('careers.job12.title'),
    location: 'Dakar',
    company: t('careers.job12.company'),
    type: 'CDI',
    typeLabel: t('careers.job12.type'),
    description: t('careers.job12.description'),
    requirements: t('careers.job12.requirements', { returnObjects: true }),
    responsibilities: t('careers.job12.responsibilities', { returnObjects: true })
  },
  {
    id: 13,
    title: t('careers.job13.title'),
    location: 'Dakar',
    company: t('careers.job13.company'),
    type: 'Stage',
    typeLabel: t('careers.job13.type'),
    description: t('careers.job13.description'),
    requirements: t('careers.job13.requirements', { returnObjects: true }),
    responsibilities: t('careers.job13.responsibilities', { returnObjects: true })
  },
  // Finances (14–17)
  {
    id: 14,
    title: t('careers.job14.title'),
    location: 'Dakar',
    company: t('careers.job14.company'),
    type: 'CDI',
    typeLabel: t('careers.job14.type'),
    description: t('careers.job14.description'),
    requirements: t('careers.job14.requirements', { returnObjects: true }),
    responsibilities: t('careers.job14.responsibilities', { returnObjects: true })
  },
  {
    id: 15,
    title: t('careers.job15.title'),
    location: 'Dakar',
    company: t('careers.job15.company'),
    type: 'CDI',
    typeLabel: t('careers.job15.type'),
    description: t('careers.job15.description'),
    requirements: t('careers.job15.requirements', { returnObjects: true }),
    responsibilities: t('careers.job15.responsibilities', { returnObjects: true })
  },
  {
    id: 16,
    title: t('careers.job16.title'),
    location: 'Dakar',
    company: t('careers.job16.company'),
    type: 'CDI',
    typeLabel: t('careers.job16.type'),
    description: t('careers.job16.description'),
    requirements: t('careers.job16.requirements', { returnObjects: true }),
    responsibilities: t('careers.job16.responsibilities', { returnObjects: true })
  },
  {
    id: 17,
    title: t('careers.job17.title'),
    location: 'Dakar',
    company: t('careers.job17.company'),
    type: 'CDD',
    typeLabel: t('careers.job17.type'),
    description: t('careers.job17.description'),
    requirements: t('careers.job17.requirements', { returnObjects: true }),
    responsibilities: t('careers.job17.responsibilities', { returnObjects: true })
  },
  // Achats (18–20)
  {
    id: 18,
    title: t('careers.job18.title'),
    location: 'Dakar',
    company: t('careers.job18.company'),
    type: 'CDI',
    typeLabel: t('careers.job18.type'),
    description: t('careers.job18.description'),
    requirements: t('careers.job18.requirements', { returnObjects: true }),
    responsibilities: t('careers.job18.responsibilities', { returnObjects: true })
  },
  {
    id: 19,
    title: t('careers.job19.title'),
    location: 'Dakar',
    company: t('careers.job19.company'),
    type: 'CDD',
    typeLabel: t('careers.job19.type'),
    description: t('careers.job19.description'),
    requirements: t('careers.job19.requirements', { returnObjects: true }),
    responsibilities: t('careers.job19.responsibilities', { returnObjects: true })
  },
  {
    id: 20,
    title: t('careers.job20.title'),
    location: 'Dakar',
    company: t('careers.job20.company'),
    type: 'CDI',
    typeLabel: t('careers.job20.type'),
    description: t('careers.job20.description'),
    requirements: t('careers.job20.requirements', { returnObjects: true }),
    responsibilities: t('careers.job20.responsibilities', { returnObjects: true })
  }
];

const Carriere = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // États des filtres appliqués
  const [searchTerm, setSearchTerm] = useState('');
  const [jobType, setJobType] = useState('');
  // États des champs saisis (avant clic sur "Rechercher")
  const [searchTermInput, setSearchTermInput] = useState('');
  const [jobTypeInput, setJobTypeInput] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 5;

  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = `${t('header.careers')} | SOCABEG`;
  }, [t]);

  // Détecter le changement de langue
  useEffect(() => {
    const handleLanguageChange = () => {
      // Réinitialiser la page lors du changement de langue
      setCurrentPage(1);
    };

    i18next.on('languageChanged', handleLanguageChange);
    
    return () => {
      i18next.off('languageChanged', handleLanguageChange);
    };
  }, []);

  // Utiliser useEffect pour réagir aux changements de langue et mettre à jour les offres d'emploi
  const [jobListings, setJobListings] = useState([]);

  useEffect(() => {
    // Récupérer les offres d'emploi depuis la fonction
    const jobs = getJobListings(t) || [];
    setJobListings(jobs);
  }, [t]);
  
  // Filtrer les offres d'emploi en fonction des termes de recherche
  const filteredJobs = Array.isArray(jobListings) ? jobListings.filter(job => {
    const matchesSearchTerm = searchTerm === '' || 
      job.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      job.company.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (job.description && job.description.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesJobType = jobType === '' || 
      job.type === jobType;
    
    return matchesSearchTerm && matchesJobType;
  }) : [];

  // Pagination
  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = filteredJobs.slice(indexOfFirstJob, indexOfLastJob);
  const totalPages = Math.ceil(filteredJobs.length / jobsPerPage);

  // Gérer la recherche
  const handleSearch = (e) => {
    e.preventDefault();
    // Appliquer les filtres saisis seulement au clic
    setSearchTerm(searchTermInput);
    setJobType(jobTypeInput);
    setCurrentPage(1);
  };

  // Générer les numéros de page pour la pagination
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <PageHero 
        title={t('careers.title')}
        subtitle={t('careers.subtitle')}
        overlayColor="socabeg-blue"
        textPosition="left"
        backgroundImage="images/hero_carrieres.png"
      />

      <div className="container mx-auto px-4 pt-8">
        {/* Formulaire de recherche */}
        <div className="bg-socabeg-blue/10 p-6 rounded-lg shadow-md mb-8">
          <form onSubmit={handleSearch}>
            <div className="grid md:grid-cols-2 gap-4 mb-4">
              <div>
                <input
                  type="text"
                  placeholder={t('careers.search.jobTitle', 'Titre d\'emploi')}
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-socabeg-blue"
                  value={searchTermInput}
                  onChange={(e) => setSearchTermInput(e.target.value)}
                />
              </div>
              <div>
                <select
                  className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-socabeg-blue"
                  value={jobTypeInput}
                  onChange={(e) => setJobTypeInput(e.target.value)}
                >
                  <option value="">{t('careers.search.allTypes')}</option>
                  {/* Les valeurs doivent correspondre exactement aux types définis dans careers.jobX.type */}
                  <option value="CDI">{t('careers.search.permanent')}</option>
                  <option value="CDD">{t('careers.search.temporary')}</option>
                  <option value="Stage">{t('careers.search.internship')}</option>
                </select>
              </div>
            </div>
            <button
              type="submit"
              className="w-full bg-socabeg-blue text-white py-3 rounded-md hover:bg-socabeg-blue-dark transition-colors font-medium"
            >
              {t('careers.search.button')}
            </button>
          </form>
        </div>

        {/* Liste des offres d'emploi */}
        <div>
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-bold">{t('careers.jobListings.title', 'Offres d\'emploi')}</h2>
            <span className="text-gray-500">{filteredJobs.length} {t('careers.results')}</span>
          </div>

          {currentJobs.length > 0 ? (
            <div className="border border-gray-200 rounded-lg overflow-hidden">
              {currentJobs.map((job) => (
                <div key={job.id} className="border-b border-gray-200 last:border-b-0 hover:bg-socabeg-blue/5">
                  <div className="p-4 flex items-start">
                    <div className="w-8 h-8 bg-socabeg-blue/10 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      {getJobIcon(job.title)}
                    </div>
                    <div className="flex-grow">
                      <div className="flex flex-col md:flex-row md:justify-between md:items-center">
                        <div>
                          <h3 className="font-semibold">{job.title}</h3>
                          <p className="text-gray-600">{job.company}</p>
                        </div>
                        <div className="mt-2 md:mt-0">
                          <span className="inline-block px-3 py-1 text-xs font-semibold bg-socabeg-blue/10 text-socabeg-blue">
                            {job.typeLabel}
                          </span>
                        </div>
                      </div>
                      <div className="flex flex-col md:flex-row md:justify-between mt-3">
                        <div className="flex items-center text-gray-500 text-sm">
                          <FaMapMarkerAlt className="mr-1" />
                          <span>{job.location}</span>
                        </div>
                        <div className="flex justify-between mt-2 md:mt-0">
                          <button 
                            onClick={() => navigate(`/carrieres/job/${job.id}`)}
                            className="text-socabeg-blue hover:underline text-sm font-medium"
                          >
                            {t('careers.viewDetails')}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-8">
              <p className="text-gray-500">{t('careers.noResults')}</p>
            </div>
          )}

          {/* Pagination */}
          {totalPages > 1 && (
            <div className="flex justify-center mt-8">
              <nav className="inline-flex">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="px-3 py-1 rounded-l-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                >
                  &lt;
                </button>
                {pageNumbers.map(number => (
                  <button
                    key={number}
                    onClick={() => setCurrentPage(number)}
                    className={`px-3 py-1 border border-gray-300 ${
                      currentPage === number
                        ? 'bg-socabeg-blue text-white'
                        : 'bg-white text-gray-500 hover:bg-gray-50'
                    }`}
                  >
                    {number}
                  </button>
                ))}
                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="px-3 py-1 rounded-r-md border border-gray-300 bg-white text-gray-500 hover:bg-gray-50 disabled:opacity-50"
                >
                  &gt;
                </button>
              </nav>
            </div>
          )}
        </div>
      </div>

    </div>
  );
};

export default Carriere;
